import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type TaskUpdateMemberResponseType = ResponseType<null>;

function useUpdateTaskMemberMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<TaskUpdateMemberResponseType>["response"],
    AxiosResponseAndError<TaskUpdateMemberResponseType>["error"],
     {
        assginedToUserId:string,
        workingHours: number,
      }
  >({
    mutationFn: (data) =>
      ApiRequest.put<TaskUpdateMemberResponseType>(
        `${requestURLs.taskMember}assignment/${data.assginedToUserId}`,data
      ),
  });

  return mutation;
}

export default useUpdateTaskMemberMutation;
